import validator from 'validator';

export const UrlValidator = (value) => {
  return validator.isURL(value, { require_protocol: false });
};

export const MobilePhoneValidator = (value) => {
  return value.length > 9 && value.length < 12 && validator.isMobilePhone(value);
};

export const PhoneValidator = (value) => {
  return value.length > 8 && value.length < 12;
};

export const PositiveIntValidator = (value) => {
  const valueStr = value.toString();
  return validator.isInt(valueStr, { min: 0 });
};

export const MaxLengthValidator = (value, max) => {
  return value.length <= max;
};

export const MinLengthValidator = (value, min) => {
  return value.length >= min;
};

export const replaceNotNumbers = (value) => {
  if (value !== 0 && !value) {
    value = '';
  }
  const valueStr = value.toString();
  return valueStr.replace(/[^0-9]+/g, '');
};

export const replaceNotPhoneNumbers = (value) => {
  if (value !== 0 && !value) {
    value = '';
  }
  const valueStr = value.toString();
  return valueStr.replace(/[^0-9+]+/g, '');
};

export const EmailValidator = (value) => {
  return validator.isEmail(value);
};

export const trimAtMaxLength = (value, maxLength) => {
  if (value !== 0 && !value) {
    value = '';
  }
  const valueStr = value.toString();
  return valueStr.substring(0, maxLength);
};

export const DateDotFormatValidator = (dateString) => {
  // Regular expression pattern to match the format "YYYY.MM."
  const pattern = /^\d{4}\.\d{1,2}(\.|$)/;

  return pattern.test(dateString);
};
